import { render, staticRenderFns } from "./comments_form_pl.vue?vue&type=template&id=0e7e8f97&scoped=true"
import script from "./comments_form_pl.vue?vue&type=script&lang=js"
export * from "./comments_form_pl.vue?vue&type=script&lang=js"
import style0 from "./comments_form_pl.vue?vue&type=style&index=0&id=0e7e8f97&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7e8f97",
  null
  
)

export default component.exports